import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { NotificationBell } from '../components/notifications/NotificationBell';

export const PilotLayout = () => {
  const { logout } = useAuth();
  return (
    <div className="foundation-shell">
      <aside className="fixed inset-y-0 left-0 w-64 overflow-y-auto bg-[#07112d] p-6 text-white">
        <Link to="/pilot/dashboard" className="text-xl font-black">AeroBott Pilot</Link>
        <nav className="mt-8 grid gap-2 text-sm font-bold">
          <p className="text-[10px] uppercase tracking-wide text-slate-400">Workspace</p>
          <Link to="/pilot/dashboard" className="hover:text-[#FF9933]">Dashboard</Link>
          <Link to="/pilot/jobs/available" className="hover:text-[#FF9933]">Available jobs</Link>
          <Link to="/pilot/matching-jobs" className="hover:text-[#FF9933]">Matched jobs</Link>
          <Link to="/pilot/quotes" className="hover:text-[#FF9933]">My quotes</Link>
          <Link to="/pilot/deliverables" className="hover:text-[#FF9933]">Deliverables</Link>
          <Link to="/pilot/messages" className="hover:text-[#FF9933]">Messages</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Public profile</p>
          <Link to="/pilot/public-profile/edit" className="hover:text-[#FF9933]">Edit public profile</Link>
          <Link to="/pilot/portfolio" className="hover:text-[#FF9933]">Portfolio projects</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Service area</p>
          <Link to="/pilot/settings/location" className="hover:text-[#FF9933]">Location & radius</Link>
          <Link to="/pilot/settings/availability" className="hover:text-[#FF9933]">Availability</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Reputation</p>
          <Link to="/pilot/reviews" className="hover:text-[#FF9933]">Reviews</Link>
          <Link to="/pilot/trust-score" className="hover:text-[#FF9933]">Trust score</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Money</p>
          <Link to="/pilot/payouts" className="hover:text-[#FF9933]">My payouts</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-[#FF9933]">Grow</p>
          <Link to="/pilot/subscription" className="hover:text-[#FF9933]">Subscription</Link>
          <Link to="/pilot/analytics" className="hover:text-[#FF9933]">Analytics</Link>

          <p className="mt-3 text-[10px] uppercase tracking-wide text-slate-400">Help</p>
          <Link to="/support/tickets" className="hover:text-[#FF9933]">Support tickets</Link>
          <Link to="/disputes" className="hover:text-[#FF9933]">My disputes</Link>
        </nav>
        <button onClick={() => void logout()} className="mt-8 w-full rounded-xl bg-[#FF9933] px-3 py-2 text-sm font-black text-slate-950">Log out</button>
      </aside>
      <main className="ml-64 min-h-screen">
        <header className="flex items-center justify-end gap-3 border-b border-slate-200 bg-white px-8 py-3">
          <NotificationBell />
        </header>
        <div className="p-8"><Outlet /></div>
      </main>
    </div>
  );
};
